import * as React from "react";
import { Component } from "react";
import {
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Glyphicon,
  HelpBlock,
} from "react-bootstrap";
import CurrencyInput from "react-currency-input";
import DividerLine from "src/components/common/DividerLine";
import { IBaseState } from "src/interfaces";
import { ISimpleSingleRateStatementProps } from "./interfaces";

export default class SimpleSingleRateStatement extends Component<
  ISimpleSingleRateStatementProps,
  IBaseState
> {
  public constructor(props: ISimpleSingleRateStatementProps) {
    super(props);

    this.state = { loading: true };

    this.handleStatementDate = this.handleStatementDate.bind(this);
    this.handleYearsWithSolar = this.handleYearsWithSolar.bind(this);
    this.handleTotalAmountDue = this.handleTotalAmountDue.bind(this);

    this.handleGridUsage = this.handleGridUsage.bind(this);
    this.handleSolarUsage = this.handleSolarUsage.bind(this);
    this.handleSolarGenerated = this.handleSolarGenerated.bind(this);

    this.handleLastMonthCredit = this.handleLastMonthCredit.bind(this);

    this.handleServiceStartDte = this.handleServiceStartDte.bind(this);
    this.handleServiceEndDate = this.handleServiceEndDate.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    const xsLabelWidthL = 6;
    const xsInputWidthL = 6;
    const smLabelWidthL = 6;
    const smInputWidthL = 6;
    const mdLabelWidthL = 6;
    const mdInputWidthL = 6;

    const xsLabelWidthR = 6;
    const xsInputWidthR = 6;
    const smLabelWidthR = 5;
    const smInputWidthR = 7;
    const mdLabelWidthR = 6;
    const mdInputWidthR = 6;

    const netGridUsage = this.props.gridUsage - this.props.solarUsage;
    const netSolarUsed = this.props.solarGenerated - this.props.solarUsage;
    let totalCredits = this.props.solarUsage + this.props.lastMonthCredit - this.props.gridUsage;
    if (totalCredits < 0) {
      totalCredits = 0;
    }
    return (
      <div className="flex">
        <div className="left-column">
          <Form horizontal={true} className="fieldset-form">
            <fieldset className="fieldset-left">
              <legend>Statement Summary</legend>
              <FormGroup controlId="statementDate" bsSize="small">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Statement Date
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    type="date"
                    bsSize="small"
                    value={new Date(this.props.statementDate).toISOString().substring(0, 10)}
                    onChange={this.handleStatementDate}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="serviceStartDate">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Service Start
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="date"
                    value={new Date(this.props.serviceStartDate).toISOString().substring(0, 10)}
                    onChange={this.handleServiceStartDte}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="serviceEndDate">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Service End
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="date"
                    value={new Date(this.props.serviceEndDate).toISOString().substring(0, 10)}
                    onChange={this.handleServiceEndDate}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="yearsWithSolar">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Years with Solar
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    type="number"
                    value={this.props.yearsWithSolar}
                    onChange={this.handleYearsWithSolar}
                    bsSize="small"
                  />
                  <HelpBlock>(Optional)</HelpBlock>
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="totalAmountDue">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Total Amount Due
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <CurrencyInput
                    className="currency-input form-control input-sm"
                    value={this.props.totalAmountDue}
                    onChangeEvent={this.handleTotalAmountDue}
                    precision={2}
                    prefix={"$"}
                    inputType="text"
                    selectAllOnFocus={true}
                  />
                </Col>
              </FormGroup>
            </fieldset>
            <fieldset className="fieldset-left">
              <legend>Electricity from Grid</legend>
              <FormGroup bsSize="small" controlId="gridUsage">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Total from Grid
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.gridUsage}
                    onChange={this.handleGridUsage}
                  />
                </Col>
              </FormGroup>
            </fieldset>
            <fieldset className="fieldset-left">
              <legend>Electricity Credited</legend>
              <FormGroup bsSize="small" controlId="solarUsage">
                <Col
                  xs={xsLabelWidthL}
                  sm={smLabelWidthL}
                  md={mdLabelWidthL}
                  componentClass={ControlLabel}
                >
                  Total Credited
                </Col>
                <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.solarUsage}
                    onChange={this.handleSolarUsage}
                  />
                </Col>
              </FormGroup>
            </fieldset>
          </Form>
        </div>
        <div className="right-column">
          <Form horizontal={true} className="fieldset-form">
            <fieldset className="fieldset-right">
              <legend>Solar Generated</legend>
              <FormGroup bsSize="small" controlId="solarGenerated">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Total Solar Generated
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.solarGenerated}
                    onChange={this.handleSolarGenerated}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="solarReceived">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Total Received by Grid
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.solarUsage}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <DividerLine
                xsOffset={xsLabelWidthR}
                smOffset={smLabelWidthR}
                mdOffset={mdLabelWidthR}
                xs={xsInputWidthR}
                sm={smInputWidthR}
                md={mdInputWidthR}
              />
              <FormGroup bsSize="small" controlId="netSolarUsed">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Net Total Solar Used
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={netSolarUsed}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
            </fieldset>
            <fieldset className="fieldset-right">
              <legend>Net Electricity</legend>
              <FormGroup bsSize="small" controlId="gridUsage">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Electricity Used
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.gridUsage}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="lastMonthCredit">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Solar Received
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.solarUsage}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <DividerLine
                xsOffset={xsLabelWidthR}
                smOffset={smLabelWidthR}
                mdOffset={mdLabelWidthR}
                xs={xsInputWidthR}
                sm={smInputWidthR}
                md={mdInputWidthR}
              />
              <FormGroup bsSize="small" controlId="netGridUsage">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Net Electricity
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={netGridUsage}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
            </fieldset>
            <fieldset className="fieldset-right">
              <legend>Carry Forward Credits</legend>
              <FormGroup bsSize="small" controlId="solarUsage">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  Solar Received
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.solarUsage}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="lastMonthCredit">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  <Glyphicon glyph="glyphicon glyphicon-plus" /> Last Month's Credit
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={this.props.lastMonthCredit}
                    onChange={this.handleLastMonthCredit}
                  />
                </Col>
              </FormGroup>
              <FormGroup bsSize="small" controlId="gridUsage">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  <Glyphicon glyph="glyphicon glyphicon-minus" /> Grid Usage
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    type="number"
                    bsSize="small"
                    value={this.props.gridUsage}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
              <DividerLine
                xsOffset={xsLabelWidthR}
                smOffset={smLabelWidthR}
                mdOffset={mdLabelWidthR}
                xs={xsInputWidthR}
                sm={smInputWidthR}
                md={mdInputWidthR}
              />
              <FormGroup bsSize="small" controlId="totalCredits">
                <Col
                  xs={xsLabelWidthR}
                  sm={smLabelWidthR}
                  md={mdLabelWidthR}
                  componentClass={ControlLabel}
                >
                  <Glyphicon glyph="glyphicon glyphicon-credit-card" /> Total Credits
                </Col>
                <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
                  <FormControl
                    bsSize="small"
                    type="number"
                    value={totalCredits}
                    readOnly={true}
                    tabIndex={-1}
                  />
                </Col>
              </FormGroup>
            </fieldset>
          </Form>
        </div>
      </div>
    );
  }

  private handleStatementDate(e: any) {
    this.props.handleStatementDate(e.target.value);
  }
  private handleYearsWithSolar(e: any) {
    this.props.handleYearsWithSolar(e.target.value);
  }
  private handleTotalAmountDue(e: any, maskedValue: any, floatValue: any) {
    this.props.handleTotalAmountDue(floatValue);
  }
  private handleGridUsage(e: any) {
    this.props.handleGridUsage(e.target.value);
  }
  private handleSolarUsage(e: any) {
    this.props.handleSolarUsage(e.target.value);
  }
  private handleSolarGenerated(e: any) {
    this.props.handleSolarGenerated(e.target.value);
  }
  private handleLastMonthCredit(e: any) {
    this.props.handleLastMonthCredit(e.target.value);
  }
  private handleServiceStartDte(e: any) {
    this.props.serviceStartDateChanged(e.target.value);
  }
  private handleServiceEndDate(e: any) {
    this.props.serviceEndDateChanged(e.target.value);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/simple/singlerate/SimpleSingleRateStatement.tsx